import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";

import logoImg from "../../assets/images/smarteyelogo.png";
import icMSP from "../../assets/images/msp-customer.png";
import { getLoggedInUser } from "../../services/authService";

export default function AppLayout() {
  const navigate = useNavigate();

  const [role, setRole] = React.useState<"superadmin" | "msp" | null>(null);

  React.useEffect(() => {
    (async () => {
      try {
        const user = await getLoggedInUser();
        const r = (user?.customRole as "superadmin" | "msp") ?? "msp";
        setRole(r);
      } catch (e) {
        console.error("Failed to get logged in user", e);
        setRole("msp");
      }
    })();
  }, []);

  if (!role) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center bg-[#EFF2F6]">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  const isSuperAdmin = role === "superadmin";

  const tabs = [
    {
      id: "msp" as const,
      label: isSuperAdmin ? "MSP" : "CUSTOMERS",
      icon: icMSP,
    },
  ];

  const goToDefault = () => {
    if (isSuperAdmin) {
      navigate("/msps", { state: { resetMspView: Date.now() } });
    } else {
      navigate("/customers", { state: { resetMspView: Date.now() } });
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#EFF2F6]">
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar
          items={tabs.map((item) => ({ ...item, active: item.id === "msp" }))}
          logo={{ img: logoImg, alt: "Smart Eye Technology" }}
          onNavigate={(id) => {
            if (id !== "msp") return;
            goToDefault();
          }}
          onLogoClick={goToDefault}
        />

        {/* Right pane */}
        <div className="flex-1 bg-[#FFFFFF] flex flex-col">
          <Header activeTab="msp" />
          <section className="px-0 -mt-0 w-full relative z-0">
            <div className="bg-white border-[#E6E8EE] w-full">
              <Outlet />
            </div>
          </section>
          <div className="flex-1" />
        </div>
      </div>
    </div>
  );
}
